/* strive-floating-widgets.js
   Reubica el botón flotante de WhatsApp (app sk-whatsapp-chat-button).
   La app lo fija abajo-IZQUIERDA (left:20px, bottom:20px) y ahí se monta encima
   de los badges del buy box en móvil. Su posición se configura en el backend de
   la app, no en el tema, y el botón vive dentro de un shadow root abierto, así
   que el CSS del tema no lo alcanza: hay que inyectar el estilo en el shadow root.
   Lo movemos a la derecha y 86px arriba del borde, para que quede por encima del
   carrito sticky de UpCart cuando este aparece (solo con productos en el carrito).
   Si algún día se corrige la posición dentro de la app, borrar este archivo y su
   <script> en layout/theme.liquid. */
(function () {
  var TAG = 'whatsapp-chat-by-squadkin';
  var CSS = '.squadkin-wrapper-container{left:auto !important;right:20px !important;bottom:86px !important;}';
  var tries = 0;

  function place() {
    var host = document.querySelector(TAG);
    if (!host || !host.shadowRoot) return false;
    if (!host.shadowRoot.querySelector('style[data-strive-wa]')) {
      var s = document.createElement('style');
      s.setAttribute('data-strive-wa', '');
      s.textContent = CSS;
      host.shadowRoot.appendChild(s);
    }
    return true;
  }

  if (place()) return;
  var iv = setInterval(function () {
    if (place() || ++tries > 60) clearInterval(iv);
  }, 500);
})();
